import { postCommWebApiModelRankConfigDetail, postCommWebApiModelRankDataList, postCommWebApiModelRankDetail, postCommWebApiModelRankList, postCommWebApiModelRankListDate, postCommWebApiModelRankTop } from '@/api/modules/commWebApi';
import { Api, Spectra, SpectraModule } from '@/decorators';

@Spectra({ namespaced: true, name: 'Ranking' })
export default class extends SpectraModule {
    @Api({ })
    commWebApiModelRankListDate = postCommWebApiModelRankListDate;
    @Api({ })
    commWebApiModelRankTop = postCommWebApiModelRankTop;
    @Api({ })
    commWebApiModelRankList = postCommWebApiModelRankList;
    @Api({ })
    commWebApiModelRankConfigDetail = postCommWebApiModelRankConfigDetail;
    @Api({ })
    commWebApiModelRankDetail = postCommWebApiModelRankDetail;
    @Api({ })
    commWebApiModelRankDataList = postCommWebApiModelRankDataList;
}
